import React, { useEffect, useState } from 'react';

import ArtworkViewModal from '@/features/assets/components/artwork/ArtworkViewModal';
import PdfViewModal from '@/features/assets/components/artwork/PdfViewModal';
import CommonImage from '@/components/CommonImage';
import { onGetLocalFromUtc } from '@/utils/Util';
import { getDocType } from '@/features/assets/utils';

const ArtworkItem = ({ artwork, onEdit, onDeleteClick, selectedArtworkToView }) => {
	const [selectedArtworkId, setSelectedArtworkId] = useState(null);
	const [isOpenPdfView, setIsOpenPdfView] = useState(false);

	useEffect(() => {
		setSelectedArtworkId(selectedArtworkToView);
	}, [selectedArtworkToView]);

	const isPSDFile = () => {
		return artwork.documentResponseList.find((doc) => doc.docType === 'ARTWORK_PHOTOSHOP_FILE')?.docUrl;
	};

	return (
		<div className="single-design-card with-editable">
			<div className="card-top">
				<div className="edit-items">
					<div className="select-and-edit d-flex justify-content-between">
						<div></div>
						<div className="option">
							<div className="dropdown">
								<button
									className="btn btn-default dropdown-toggle"
									type="button"
									id="menu1"
									data-toggle="dropdown"
									aria-expanded="false"
								>
									<CommonImage src={`/icons/more_icon.svg`} alt="more-icon" />
								</button>
								<ul
									className="dropdown-menu dropdown-menu-right shadow-lg"
									role="menu"
									aria-labelledby="menu1"
									x-placement="bottom-end"
								>
									<li>
										<span onClick={() => onEdit(artwork?.id)}>Edit</span>
									</li>
									<li>
										<span
											className="red"
											onClick={() => {
												onDeleteClick(artwork?.id);
											}}
										>
											Delete
										</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<CommonImage
					src={
						artwork?.documentResponseList?.length > 0 &&
						artwork.documentResponseList.find((doc) => doc.docType === 'ARTWORK_FRONT_IMAGE')
							?.docUrl &&
						artwork.documentResponseList.find((doc) => doc.docType === 'ARTWORK_FRONT_IMAGE')
							?.docUrl
					}
					alt="card-image"
					onClick={() => setSelectedArtworkId(artwork?.id)}
					isStatic={false}
				/>
			</div>
			<div className="card-content" onClick={() => setSelectedArtworkId(artwork?.id)}>
				<h3 className="semibold-12 weight-600 design-title gray_dark_01">{artwork?.name}</h3>
				<div className="card-info d-flex justify-content-between">
					<ul className="list-item-with-dot">
						<li className="regular-1 gray_dark_02">
							Used Artwork: {artwork?.usedArtboardCount}/{artwork?.totalArtboardCount}{' '}
							{artwork?.moodTagResponse?.text}
						</li>
						<li className="regular-12 gray_dark_02">
							{onGetLocalFromUtc(artwork?.createdAt, 'DD MMM, YYYY')}
						</li>
						{artwork?.designedByResponse && (
							<li className="regular-12 gray_dark_02">{artwork?.designedByResponse?.name}</li>
						)}
					</ul>
				</div>
			</div>
			{selectedArtworkId && (
				<ArtworkViewModal
					selectedFileInfo={artwork}
					onClose={() => setSelectedArtworkId(null)}
					onOpenPdfView={() => setIsOpenPdfView(true)}
					setSelectedArtworkId={setSelectedArtworkId}
					isPSDFile={isPSDFile}
				/>
			)}
			{isOpenPdfView && (
				<PdfViewModal
					onClose={() => {
						setIsOpenPdfView(false);
						setSelectedArtworkId(artwork?.id);
					}}
					fileUrl={
						artwork?.documentResponseList?.length > 0 &&
						artwork.documentResponseList.find((doc) => getDocType(doc.docType))?.docUrl
					}
					modalTitle="Artwork PDF View"
				/>
			)}
		</div>
	);
};

export default ArtworkItem;
